type CompanyRouteInput = string | { alias?: string | null; id: string };

const COMPANY_UUID_AT_END_PATTERN =
  /(?:^|-)([0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12})$/i;

export function getCompanyProfilePath(company: CompanyRouteInput): string {
  if (typeof company === 'string') {
    return `/cong-ty/${encodeURIComponent(company)}`;
  }

  const alias = company.alias?.trim() || company.id.trim();

  return `/cong-ty/${encodeURIComponent(alias)}`;
}

export function getCompanyIdFromProfileSegment(segment: string): string {
  let decodedSegment = segment;

  try {
    decodedSegment = decodeURIComponent(segment);
  } catch {
    // Keep the raw segment so the upstream not-found handling stays deterministic.
  }
  const uuidMatch = decodedSegment.match(COMPANY_UUID_AT_END_PATTERN);

  return uuidMatch?.[1] ?? decodedSegment;
}
